import React, { useState } from 'react';
import { connect } from 'react-redux';
import { AppState } from '@Redux/store';
import { Dispatch } from '@Redux/type';
import { container } from '@Container';
import { TYPES } from '@Types';
import { useParams } from 'react-router-dom';
import { MagicPathAction } from '@Redux/actions/ninthAge/MagicPathAction';
import { Carousel, CarouselControl, CarouselIndicators, CarouselItem, Row } from 'reactstrap';
import { magicPathSpellPresenter } from '@Selectors/ninthage/magicPathSpellPresenter';
import MagicSpellComponent from '../../components/MagicSpellComponent/MagicSpellComponent';
import Repeater from '@Utils/Repeater';
import { MagicSpellView } from '@Selectors/ninthage/view/MagicSpellView';

const MagicPathSpellsPageIndex: React.FC<MagicPathSpellsPageIndexProps> = ({
                                                                             spells,
                                                                             loadPath,
                                                                           }) => {
  const params = useParams();

  const [width, setWidth] = React.useState(window.innerWidth);
  const MAX_WIDTH_CAROUSEL = 700;

  React.useEffect(() => {
    if(params.magic_path_id)
      loadPath(params.magic_path_id);

    const handleResizeWindow = () => setWidth(window.innerWidth);
    // subscribe to window resize event "onComponentDidMount"
    window.addEventListener("resize", handleResizeWindow);
    return () => {
      // unsubscribe "onComponentDestroy"
      window.removeEventListener("resize", handleResizeWindow);
    };
  }, []);

  const [activeIndex, setActiveIndex] = useState(0);
  const [animating, setAnimating] = useState(false);

  const onExiting = () => setAnimating(true);
  const onExited = () => setAnimating(false);

  const next = () => {
    if (animating) return;
    const nextIndex = activeIndex === spells.length - 1 ? 0 : activeIndex + 1;
    setActiveIndex(nextIndex);
  }

  const previous = () => {
    if (animating) return;
    const nextIndex = activeIndex === 0 ? spells.length - 1 : activeIndex - 1;
    setActiveIndex(nextIndex);
  }

  const goToIndex = (newIndex: number) => {
    if (animating) return;
    setActiveIndex(newIndex);
  }

  if (width > MAX_WIDTH_CAROUSEL) {
    return <div>
      <Row className={'justify-content-center'}>
        <Repeater data={spells} indexPrefix='spell'>
          {
            (item: MagicSpellView) => <MagicSpellComponent spell={item} carousel={false}/>
          }
        </Repeater>
      </Row>
    </div>
  }

  const slides = spells.map((spell) => {
    return (<CarouselItem onExiting={onExiting} onExited={onExited} key={spell.id}>
      <MagicSpellComponent spell={spell} carousel={true}/>
    </CarouselItem>);
  });

  return <Carousel activeIndex={activeIndex} next={next} previous={previous} interval={false} dark={true}>
    <CarouselIndicators items={spells} activeIndex={activeIndex} onClickHandler={goToIndex}/>
    {slides}
    <CarouselControl direction="prev" directionText="Previous" onClickHandler={previous}/>
    <CarouselControl direction="next" directionText="Next" onClickHandler={next}/>
  </Carousel>;
};

const mapStateToProps = (state: AppState) => ({
  spells: magicPathSpellPresenter(state)
});

const mapDispatchToProps = (dispatch: Dispatch) => {

  const action = container.get<MagicPathAction>(TYPES.Actions.MagicPathAction);

  return {
    loadPath: (magicPathId: string) => dispatch(action.fetchData(parseInt(magicPathId))),
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(MagicPathSpellsPageIndex);

type MagicPathSpellsPageIndexProps = ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps>